import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/cieloazul310/Documents/github/gatsby-aoi/gatsby-starter-aoi-blog/src/templates/default.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`MDX Example`}</h2>
    <p>{`こんにちは。こちらは `}<a parentName="p" {...{
        "href": "https://github.com/cieloazul310/gatsby-theme-aoi",
        "title": "Gatsby Theme Aoi"
      }}>{`Gatsby Theme Aoi`}</a>{` を使ったブログのサンプルページです。`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/eea4a/IMG_8906.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.49999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUBBP/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAFkpQWHCm//xAAbEAACAwADAAAAAAAAAAAAAAABAgAREgMTIf/aAAgBAQABBQIcymdlxRsK7UpOk9X/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEv/aAAgBAwEBPwGT/8QAFREBAQAAAAAAAAAAAAAAAAAAEBL/2gAIAQIBAT8Bo//EABoQAAICAwAAAAAAAAAAAAAAAAABETEQEnH/2gAIAQEABj8CnZcLRKZZOP/EABsQAAMBAAMBAAAAAAAAAAAAAAABESExQVFx/9oACAEBAAE/IUGn4ZGpLr1lpKWa4IM04tttOQ9Z/9oADAMBAAIAAwAAABB87//EABcRAAMBAAAAAAAAAAAAAAAAAAABIRH/2gAIAQMBAT8QWHCn/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAh/9oACAECAQE/ENmyF//EABsQAQADAQEBAQAAAAAAAAAAAAEAESExYUFR/9oACAEBAAE/ECgF+AX2052IejwXReZ8mYglss8lug5CApVsxdR1n//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Aoi No Mon",
            "title": "Aoi No Mon",
            "src": "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/4b190/IMG_8906.jpg",
            "srcSet": ["/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/e07e9/IMG_8906.jpg 200w", "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/066f9/IMG_8906.jpg 400w", "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/4b190/IMG_8906.jpg 800w", "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/e5166/IMG_8906.jpg 1200w", "/gatsby-starter-aoi-blog/static/42bf219d215f21adec34b959a8b74c44/eea4a/IMG_8906.jpg 1280w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h3>{`Gatsby Theme Aoi の紹介`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/cieloazul310/gatsby-theme-aoi",
        "title": "Gatsby Theme Aoi"
      }}>{`Gatsby Theme Aoi`}</a>{` は自作の Gatsby テーマです。`}<br parentName="p"></br>{`
`}{`Material-UI をベースに TypeScript で書かれています。`}</p>
    <h4>{`Gatsby`}</h4>
    <p><a parentName="p" {...{
        "href": "https://gatsbyjs.org",
        "title": "Gatsby JS"
      }}>{`Gatsby`}</a>{` は React 製の静的ページ作成フレームワークです。`}</p>
    <h4>{`Gatsby Theme`}</h4>
    <p><a parentName="p" {...{
        "href": "https://gatsbyjs.org/docs/themes/",
        "title": "Gatsby JS"
      }}>{`Gatsby Theme`}</a>{` はレイアウトやページ生成機能など特定の役割に特化させたモジュールです。`}</p>
    <h3>{`Getting Started`}</h3>
    <p>{`インストール`}</p>
    <p><div parentName="p" {...{
        "className": "gatsby-highlight",
        "data-language": "tsx"
      }}><pre parentName="div" {...{
          "className": "language-tsx"
        }}><code parentName="pre" {...{
            "className": "language-tsx"
          }}><span parentName="code" {...{
              "className": "token keyword"
            }}>{`import`}</span>{` `}<span parentName="code" {...{
              "className": "token operator"
            }}>{`*`}</span>{` `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`as`}</span>{` React `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`from`}</span>{` `}<span parentName="code" {...{
              "className": "token string"
            }}>{`'react'`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`
`}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`import`}</span>{` Typography `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`from`}</span>{` `}<span parentName="code" {...{
              "className": "token string"
            }}>{`'@material-ui/core/Typography'`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`
`}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`from`}</span>{` `}<span parentName="code" {...{
              "className": "token string"
            }}>{`'gatsby-theme-aoi/src/layout'`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`

`}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`function`}</span>{` `}<span parentName="code" {...{
              "className": "token function"
            }}>{`Page`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span>{` `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{`
  `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`return`}</span>{` `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`(`}</span>{`
    `}<span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`<`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Layout`}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span><span parentName="code" {...{
              "className": "token plain-text"
            }}>{`
      `}</span><span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`<`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Typography`}</span></span>{` `}<span parentName="span" {...{
                "className": "token attr-name"
              }}>{`variant`}</span><span parentName="span" {...{
                "className": "token attr-value"
              }}><span parentName="span" {...{
                  "className": "token punctuation attr-equals"
                }}>{`=`}</span><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`"`}</span>{`h2`}<span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`"`}</span></span>{` `}<span parentName="span" {...{
                "className": "token attr-name"
              }}>{`gutterBottom`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span><span parentName="code" {...{
              "className": "token plain-text"
            }}>{`
        Hello, World
      `}</span><span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`</`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Typography`}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span><span parentName="code" {...{
              "className": "token plain-text"
            }}>{`
      `}</span><span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`<`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Typography`}</span></span>{` `}<span parentName="span" {...{
                "className": "token attr-name"
              }}>{`paragraph`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span><span parentName="code" {...{
              "className": "token plain-text"
            }}>{`This is Gatsby Theme Aoi layout example.`}</span><span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`</`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Typography`}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span><span parentName="code" {...{
              "className": "token plain-text"
            }}>{`
    `}</span><span parentName="code" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token tag"
              }}><span parentName="span" {...{
                  "className": "token punctuation"
                }}>{`</`}</span><span parentName="span" {...{
                  "className": "token class-name"
                }}>{`Layout`}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`)`}</span><span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span>{`
`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`}`}</span>{`

`}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`export`}</span>{` `}<span parentName="code" {...{
              "className": "token keyword"
            }}>{`default`}</span>{` Page`}<span parentName="code" {...{
              "className": "token punctuation"
            }}>{`;`}</span></code></pre></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      